import townWarning from "../up_compiler/home/town_warning";

up.on("up:fragment:inserted", function (event, fragment) {
  if (fragment.id === "animators_list") {
    townWarning(window.up_filter_city_selector);
  }
});
